"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.context = void 0;
var context;
(function (context) {
    /**
     * Inspired by Kotlin "run" function. This method exists as a utility to better allow readable one line statements that deal with nullish values
     * in the middle of themselves, such as map references
     * @param item
     * @param func
     */
    context.run = (item, func) => {
        if (item !== undefined && item !== null)
            return func(item);
        return item; // item must be undefined or null
    };
    context.lazy = (func) => {
        let result;
        let hasCalled = false;
        return () => {
            if (!hasCalled) {
                result = func();
                hasCalled = true;
            }
            return result;
        };
    };
})(context || (exports.context = context = {}));
